import { courses } from './courses'
import { getStaticPagesForPrerender } from './staticPages'

export type SocialImageTarget = {
  pagePath: string
  title: string
  subtitle: string
  category?: string
  level?: string
}

export function socialImagePath(pagePath: string): string {
  return `/og${pagePath}.png`
}

export function getSocialImageTargets(): SocialImageTarget[] {
  return [
    {
      pagePath: '/courses',
      title: 'Courses & Programs',
      subtitle: 'AI, Web Dev, Design & Marketing tracks from Sylhet',
    },
    ...courses.map((course) => ({
      pagePath: `/courses/${course.slug}`,
      title: course.title,
      subtitle: course.subtitle,
      category: course.category,
      level: course.level,
    })),
    ...getStaticPagesForPrerender().map((page) => ({
      pagePath: page.path,
      title: page.h1,
      subtitle: page.kind === 'local' ? 'Sylhet, Bangladesh' : 'Skillo Academy',
    })),
  ]
}
